export default __webpack_public_path__ + "static/media/description-2.d78c6aca.svg";